import { useTour } from '../../../context/TourContext';
import TourPopover from './TourPopover';
import './styles.css';

const PADDING = 8;
const BORDER_RADIUS = 8;
const HEADER_HEIGHT = 64;

export default function TourOverlay() {
  const { isActive, targetRect, targetRects, currentStep } = useTour();

  if (!isActive) return null;

  // noOverlay steps (e.g. centered reflection messages) render only the
  // popover — no dim, no spotlight ring, no loading state. The popover's
  // 'center' placement handles its own positioning from a synthetic rect.
  if (currentStep?.noOverlay) {
    return (
      <div className="tour-overlay-container">
        <TourPopover />
      </div>
    );
  }

  // Build the list of rects to spotlight. Multi-target steps populate
  // `targetRects`; single-target falls back to `targetRect`.
  const rectsToSpotlight = targetRects && targetRects.length
    ? targetRects
    : (targetRect && targetRect.width > 0 ? [targetRect] : []);
  const hasTarget = rectsToSpotlight.length > 0;

  // SVG mask approach: overlay starts below the header (64px)
  const viewportW = window.innerWidth;
  const viewportH = window.innerHeight - HEADER_HEIGHT;

  const cutouts = rectsToSpotlight.map(rect => ({
    x: rect.left - PADDING,
    y: rect.top - HEADER_HEIGHT - PADDING,
    w: rect.width + PADDING * 2,
    h: rect.height + PADDING * 2,
  }));

  return (
    <div className="tour-overlay-container">
      <svg className="tour-overlay-svg" viewBox={`0 0 ${viewportW} ${viewportH}`}>
        <defs>
          <mask id="tour-spotlight-mask">
            {/* White = visible (dark overlay shows), black = hidden (cutout) */}
            <rect x="0" y="0" width={viewportW} height={viewportH} fill="white" />
            {cutouts.map((c, i) => (
              <rect
                key={i}
                x={c.x}
                y={c.y}
                width={c.w}
                height={c.h}
                rx={BORDER_RADIUS}
                ry={BORDER_RADIUS}
                fill="black"
              />
            ))}
          </mask>
        </defs>
        <rect
          x="0"
          y="0"
          width={viewportW}
          height={viewportH}
          fill="rgba(0,0,0,0.6)"
          mask="url(#tour-spotlight-mask)"
        />
      </svg>

      {/* Glowing ring around each cutout */}
      {cutouts.map((c, i) => (
        <div
          key={i}
          className="tour-spotlight-ring"
          style={{
            top: c.y,
            left: c.x,
            width: c.w,
            height: c.h,
            borderRadius: BORDER_RADIUS,
          }}
        />
      ))}

      {/* Popover */}
      {hasTarget && currentStep && <TourPopover />}

      {/* Loading state when target not found yet */}
      {!hasTarget && currentStep && (
        <div className="tour-loading">
          <div className="tour-loading-spinner" />
          <p>Looking for the next element...</p>
        </div>
      )}
    </div>
  );
}
